define('presentation/settings/webChats/facades/webChatWidgetsFacade',[
    'common/storage/commonState',
    'externalDependencies/clientWebSocket',
    'presentation/settings/webChats/presentationObjects/webChatWidgetPresentationObject',
    'presentation/settings/webChats/presentationObjects/webChatWidgetDomainPresentationObject',
    'settings/navigationConfiguration'
], function () {
    const WebChatWidgetPresentationObjectConstructor = require('presentation/settings/webChats/presentationObjects/webChatWidgetPresentationObject');
    const WebChatWidgetDomainPresentationObjectConstructor = require('presentation/settings/webChats/presentationObjects/webChatWidgetDomainPresentationObject');

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const webChatSocket = clientWebSocket.forApplication("webChatWidget");

    const _navigationConfiguration = require('settings/navigationConfiguration');

    let _promiseFactory = null;

    const _buildWebChatDomainPresentationObject = (domain) => {
        const authorizedDomainPresentationObject = new  WebChatWidgetDomainPresentationObjectConstructor();
        authorizedDomainPresentationObject.webChatWidgetAuthorizedDomainId = domain.webChatWidgetAuthorizedDomainId;
        authorizedDomainPresentationObject.domain = domain.domain;
        return authorizedDomainPresentationObject;
    };

    const _buildWebChatWidgetPresentationObject = (widget) => {
        const webChatWidgetPresentationObject = new  WebChatWidgetPresentationObjectConstructor();
        webChatWidgetPresentationObject.webChatWidgetId = widget.webChatWidgetId;
        webChatWidgetPresentationObject.displayName = widget.displayName;
        webChatWidgetPresentationObject.launcherTextColor = widget.launcherTextColor;
        webChatWidgetPresentationObject.launcherBackgroundColor = widget.launcherBackgroundColor;
        webChatWidgetPresentationObject.welcomeMessage = widget.welcomeMessage;
        webChatWidgetPresentationObject.liveReceptionistScriptId = widget.liveReceptionistScriptId;
        webChatWidgetPresentationObject.authorizedDomains = widget.authorizedDomains.map(_buildWebChatDomainPresentationObject);
        webChatWidgetPresentationObject.editWebChatWidgetUrl = _navigationConfiguration.routesById.editWebChatWidget.baseUrl + widget.webChatWidgetId;
        return webChatWidgetPresentationObject;
    };

    const _getWebChatWidgets = () => {
        return _promiseFactory.defer((promise) => {
            webChatSocket.send('getWebChatWidgets', { }, response => {
                const webChatWidgetPresentationObjects = response.map(_buildWebChatWidgetPresentationObject);
                promise.resolve(webChatWidgetPresentationObjects);
            });
        });
    };

    const _deleteWebChatWidget = (webChatWidgetId) => {
        return _promiseFactory.defer((promise) => {
            webChatSocket.send('deleteWebChatWidget', { webChatWidgetId }, response => {
                promise.resolve(response);
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function () {
        const self = this;
        self.init = _init;
        self.deleteWebChatWidget = _deleteWebChatWidget;
        self.getWebChatWidgets = _getWebChatWidgets;
    };
});

